var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Code, Divider, Heading, Image, Link, ListItem, OrderedList, Table, Tbody, Td, Text, Th, Thead, Tr, UnorderedList } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { BLOCK_CSS } from '@/types';
import { REGEX } from '@/utils';
export const MarkdownBase = (_a) => {
    var { markdown = '' } = _a, rest = __rest(_a, ["markdown"]);
    if (!markdown)
        return null;
    const renderMarkdownComponents = () => {
        const components = {
            code: Code,
            img: Image,
            li: ListItem,
            ol: OrderedList,
            table: Table,
            tbody: Tbody,
            td: Td,
            th: Th,
            thead: Thead,
            tr: Tr,
            ul: UnorderedList,
            a: (props) => (_jsx(Link, Object.assign({}, props, { color: 'lightBlue.60', target: '_blank', textDecoration: 'underline !important' }))),
            b: (props) => _jsx(Text, Object.assign({}, props, { as: 'b' })),
            blockquote: (props) => _jsx(Code, Object.assign({}, props, { as: 'blockquote' })),
            del: (props) => _jsx(Text, Object.assign({}, props, { as: 'del' })),
            em: (props) => _jsx(Text, Object.assign({}, props, { as: 'em' })),
            hr: () => _jsx(Divider, { borderColor: 'darkBrandBlue.70', opacity: '1' }),
            i: (props) => _jsx(Text, Object.assign({}, props, { as: 'i' })),
            p: (props) => _jsx(Text, Object.assign({}, props, { as: 'p' })),
            pre: (props) => _jsx(Code, Object.assign({}, props, { as: 'pre' })),
            text: (props) => _jsx(Text, Object.assign({}, props, { as: 'span' }))
        };
        for (const [h, size] of Object.entries(BLOCK_CSS.HeadingSize)) {
            components[h] = (props) => (_jsx(Heading, Object.assign({ as: h, fontSize: size }, props, { color: 'inherit' })));
        }
        return components;
    };
    const formatMarkdown = (text) => {
        const formatters = [
            { pattern: REGEX.MARKDOWN_UNDERLINE, replacement: '<u>$1</u>' },
            { pattern: REGEX.MARKDOWN_STRIKE_THROUGH, replacement: '<del>$1</del>' }
        ];
        return formatters.reduce((a, f) => a.replace(f.pattern, f.replacement), text);
    };
    const markdownData = formatMarkdown(markdown);
    const components = renderMarkdownComponents();
    return (_jsx(Box, Object.assign({}, rest, { __css: {
            'p,hr': {
                my: 'var(--chakra-sizes-2)'
            },
            'p:first-of-type,hr:first-of-type': {
                mt: 0
            },
            'p:last-of-type,hr:last-of-type': {
                mb: 0
            }
        } }, { children: _jsx(ReactMarkdown, Object.assign({ components: components, rehypePlugins: [rehypeRaw] }, { children: markdownData })) })));
};
